import { Link } from "react-router-dom";

const DoctorCard = ({ id, img, name = "", text }) => {

  const shortName =
    name.length > 15 ? name.slice(0, 15) + "..." : name;

  return (
    <Link
      to={`/doctor/${id}`}
      className="bg-white hover:scale-95 active:bg-[#dadada] py-5 px-2
      rounded-[15px] flex flex-col justify-center items-center mt-2 transition"
    >

      <img
        src={img || "/images/doctor-placeholder.png"}
        alt={name}
        className="w-20 h-20 rounded-full object-contain bg-gray-100 p-1 mb-3"
      />

      <h6 className="font-medium mb-1 text-center">
        {shortName}
      </h6>

      <p className="text-[#707070] text-[13px] text-center line-clamp-1">
        {text}
      </p>

    </Link>
  );
};

export default DoctorCard;
